import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropdown from '../Dropdown';

const propTypes = {
  help: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.any, label: PropTypes.string })),
  required: PropTypes.bool,
  value: PropTypes.any,
  weight: PropTypes.number,
  multi: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  onWrongLength: PropTypes.func
};

const defaultProps = {
  required: true
};

class DropdownField extends Component {
  render() {
    const { id, label, required, onChange, options, value, className, multi, min, max, onWrongLength } = this.props;
    const inputProps = { value, onChange, options, required, multi, min, max, onWrongLength };

    return (
      <div className={`responsive-field ${className}`}>
        {!!label && (
          <label className="responsive-field__label" htmlFor={id}>
            {label}
          </label>
        )}
        <div className="responsive-field__input">
          <Dropdown {...inputProps} />
        </div>
      </div>
    );
  }
}

DropdownField.propTypes = propTypes;
DropdownField.defaultProps = defaultProps;

export default DropdownField;
